export const CREDIT_CARD_CODES = {
  AMEX: 'AMEX',
  DISCOVER: 'DI',
  JCB: 'JCB',
  MASTERCARD: 'MC',
  PAY_PAL: 'PP',
  UNION_PAY: 'CUP',
  VISA: 'VI',
};
